import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import ComeFunzionaPage from './pages/ComeFunzionaPage';
import FornitoriPage from './pages/FornitoriPage';
import ChiSiamoPage from './pages/ChiSiamoPage';
import Footer from './components/Footer';

function App() {
  const [currentPage, setCurrentPage] = useState('');

  useEffect(() => {
    // Handle route changes
    const handleRouteChange = () => {
      const path = window.location.pathname.replace('/', '') || 'home';
      // Scroll immediately before state change
      window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
      setCurrentPage(path);
    };

    // Listen for popstate (browser back/forward)
    window.addEventListener('popstate', handleRouteChange);
    
    // Set initial page
    handleRouteChange();

    return () => {
      window.removeEventListener('popstate', handleRouteChange);
    };
  }, []);

  const renderPage = () => {
    switch (currentPage) {
      case 'home':
      case '':
        return <HomePage />;
      case 'come-funziona':
        return <ComeFunzionaPage />;
      case 'fornitori':
        return <FornitoriPage />;
      case 'chi-siamo':
        return <ChiSiamoPage />;
      default:
        return <HomePage />;
    }
  };

  return (
    <div className="App">
      <Header currentPage={currentPage} />
      {renderPage()}
      <Footer />
    </div>
  );
}

export default App;